export interface InvoiceForCurrencyForLegalEntity {
  legalEntity: string;
  currencyTransactions: CurrencyTransaction[];
}

export interface CurrencyTransaction {
  currency: string;
  transactions: Transaction[];
}

export interface Transaction {
  id: number;
  eInvoiceId?: string;
  type: TransactionType;
  issueDate: string;
  dueDate?: string;
  openAmount: number;
  documentId?: string;
  amount: number;
  paymentMedia: TransactionPaymentMedia;
}

export enum TransactionType {
  CHEQUE = 'CHEQUE',
  CREDIT_NOTE = 'CREDIT_NOTE',
  DEBIT_NOTE = 'DEBIT_NOTE',
  INVOICE = 'INVOICE',
  PAYMENT = 'PAYMENT',
  UNMATCHED_PAYMENT = 'UNMATCHED_PAYMENT'
}

export enum TransactionPaymentMedia {
  W_LCR = 'W_LCR',
  IR_L_C = 'IR_L_C',
  B_G = 'B_G',
  WIRE_TRANSFER = 'WIRE_TRANSFER',
  CAD = 'CAD',
  DD = 'DD',
  BANK_AVAL = 'BANK_AVAL',
  GS = 'GS',
  PL_BO = 'PL_BO',
  RIBA = 'RIBA',
  DRA = 'DRA',
  GIRO = 'GIRO',
  PAG = 'PAG',
  CON = 'CON',
  CADPP = 'CADPP',
  IR_L_CS = 'IR_L_CS',
  CH = 'CH',
  ACH = 'ACH',
  CASH = 'CASH',
  SDDB2B = 'SDDB2B',
  CRO = 'CRO',
  URG = 'URG',
  SDDB2C = 'SDDB2C',
  SF = 'SF',
  DT = 'DT',
  TPM = 'TPM',
  PIA = 'PIA',
  WCO = 'WCO',
  BD = 'BD',
  SLC = 'SLC',
  Other = 'Other'
}
